import { useEffect } from "react";

export const useEffectAsync = (effect, deps) => {
    useEffect(() => {
        effect();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
